import { CommonModule } from '@angular/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UtilsService } from '../../../../services/utils.service';
import { ImportsModule } from '../../../imports/imports';
import { CadSkeletonSpec, resolveCadSkeleton } from './cad-skeleton.model';

@Component({
  selector: 'app-skeleton',
  templateUrl: './skeleton.component.html',
  styleUrl: './skeleton.component.scss',
  imports: [
    CommonModule,
    ImportsModule
  ]
})
export class SkeletonComponent implements OnInit, OnDestroy {
  /** Names which skeleton to draw. See cad-skeleton.model.ts for the CAD steps. */
  @Input() id: any;
  @Input() columns: any;
  @Input() paginator!: boolean;
  @Input() rowCount!: number;
  @Input() size!: any;
  rowsArray: any;

  constructor(
    private utilsService: UtilsService
  ) { }

  ngOnInit(): void {
    this.utilsService.loader.set(true);
    this.rowsArray = Array.from({ length: this.rowCount || 6 }, (_, index) => ({
      id: index + 1,
      opacity: index < 3 ? 1 : Math.max(1 - (index - 3) * 0.3, 0),
    }));
  }

  ngOnDestroy(): void {
    this.utilsService.loader.set(false);
  }

  /**
   * The CAD-step skeleton for the current id, or null for every other id.
   *
   * This is read straight from the template, so it is recomputed on each change
   * detection run. That is deliberate: the Tables step changes `id` whenever the
   * user picks a different table, and a plain lookup is cheap enough to just redo.
   */
  get cadSpec(): CadSkeletonSpec | null {
    return resolveCadSkeleton(this.id);
  }

  /**
   * A list of `count` numbers, for repeating one shape that many times.
   *
   * @for needs something to loop over, and a skeleton has no real data to loop
   * over yet. Each list is built once and kept, so the template hands back the same
   * array every time and Angular does not rebuild the grey boxes on every check.
   */
  range(count: number | undefined): number[] {
    const length = Math.max(0, count ?? 0);
    let list = this.rangeCache.get(length);
    if (!list) {
      list = Array.from({ length }, (_, index) => index);
      this.rangeCache.set(length, list);
    }
    return list;
  }

  private readonly rangeCache = new Map<number, number[]>();
}
